/* HTML EXAMPLE:
  <div data-controller="lazy-load"
     data-lazy-load-url-value="/path/to/partial">
    <div data-lazy-load-target="output">
      <!-- Partial content will be loaded here -->
    </div>
  </div>

  Also mounted on table rows (glance report tables):
  <tbody data-controller="lazy-load" data-lazy-load-url-value="/path/to/partial">
    <tr data-lazy-load-target="output"><!-- cells load here --></tr>
  </tbody>
*/

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["output"];
  static values = { url: String };

  connect() {
    this.loadPartial();
  }

  loadPartial() {
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then((html) => (this.outputTarget.innerHTML = html))
      .catch((error) => {
        console.error("Error loading the partial:", error);
        this.renderError();
      });
  }

  // Error responses (e.g. a proxy timeout page) must never be injected into
  // the DOM — their <style> tags apply globally and wreck the page.
  renderError() {
    const message = "Failed to load";
    this.outputTarget.innerHTML =
      this.outputTarget.tagName === "TR"
        ? `<td colspan="9" class="py-2.5 px-4 text-sm text-red-600">${message}</td>`
        : `<span class="text-sm text-red-600">${message}</span>`;
  }
}
